import { render, staticRenderFns } from "./ServiceStatusWidget.vue?vue&type=template&id=124dabeb&scoped=true"
import script from "./ServiceStatusWidget.vue?vue&type=script&lang=js"
export * from "./ServiceStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./ServiceStatusWidget.vue?vue&type=style&index=0&id=124dabeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124dabeb",
  null
  
)

export default component.exports